/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PostfachInputs */

const de__field_postfach = /** @type {(inputs: _Field_PostfachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postfach`)
};

/**

* @param {_Field_PostfachInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_postfach = /** @type {((inputs?: _Field_PostfachInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PostfachInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_postfach(inputs)
});